package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

/**
 * Image data returned in post responses
 */
@Serializable
data class PostImageDto(
    val id: Int,
    val url: String,
    val originalName: String,
    val mimeType: String,
    val width: Int? = null,
    val height: Int? = null,
)

/**
 * Full image record data
 */
@Serializable
data class ImageDto(
    val id: Int,
    val objectKey: String,
    val originalName: String,
    val mimeType: String,
    val size: Int,
    val width: Int? = null,
    val height: Int? = null,
    val sha256Hash: String,
)

/**
 * Request to generate a presigned upload URL
 */
@Serializable
data class ImageUploadUrlRequestDto(
    val fileName: String,
    val mimeType: String,
    val contentLength: Int,
)

/**
 * Response with presigned upload URL
 */
@Serializable
data class ImageUploadUrlResponseDto(
    val uploadUrl: String,
    val objectKey: String,
    val expiresAt: String,
)

/**
 * Request to confirm image upload
 */
@Serializable
data class ImageConfirmRequestDto(
    val objectKey: String,
)
